// extracted by mini-css-extract-plugin
module.exports = {"buttonOn":"Sex_buttonOn__3p-eD","buttonOff":"Sex_buttonOff__3tysU","generalButton":"Sex_generalButton__2DEkO","validate":"Sex_validate__1AmjD"};